import React from 'react';
import { useSelector } from 'react-redux';

import {
  EDIT_PAUSE_DURATION_MODAL_STAGES,
  editPauseDurationModalStageSelector,
} from 'features/courseResume';
import EditDurationModalSuccessStage from '../EditDurationModalSuccessStage';
import EditDurationModalUpdateStage from '../EditDurationModalUpdateStage';

function EditDurationModalStageRenderer() {
  const modalStage = useSelector(editPauseDurationModalStageSelector);

  switch (modalStage) {
    case EDIT_PAUSE_DURATION_MODAL_STAGES.update:
      return <EditDurationModalUpdateStage />;
    case EDIT_PAUSE_DURATION_MODAL_STAGES.success:
      return <EditDurationModalSuccessStage />;
    default:
      return null;
  }
}

export default EditDurationModalStageRenderer;
